var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#90979B",
    clipPath: "url(#picture-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32.167 0H8.833A8.343 8.343 0 00.5 8.333v23.334A8.343 8.343 0 008.833 40h23.334a8.343 8.343 0 008.333-8.333V8.333A8.343 8.343 0 0032.167 0zM8.833 3.333h23.334a5 5 0 015 5v23.334a4.918 4.918 0 01-.5 2.141L21.395 18.537a8.333 8.333 0 00-11.787 0L3.833 24.31V8.333a5 5 0 015-5zm0 33.334a5 5 0 01-5-5v-2.644l8.13-8.13a5.002 5.002 0 017.074 0l15.271 15.274a4.921 4.921 0 01-2.141.5H8.833z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.167 17.5a5.833 5.833 0 100-11.666 5.833 5.833 0 000 11.666zm0-8.333a2.5 2.5 0 110 5 2.5 2.5 0 010-5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "picture-icon"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z",
    transform: "translate(.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.2da8c7be.svg";
export { ForwardRef as ReactComponent };